export const translations = {
  en: {
    // Navigation
    nav: {
      home: 'Home',
      apps: 'Apps',
      services: 'Services',
      about: 'About',
      contact: 'Contact',
      getInTouch: 'Get In Touch',
    },
    
    // Hero Section
    hero: {
      badge: 'App Development Studio',
      headline: 'Crafting Digital Experiences That Move People',
      description: 'We build innovative mobile applications that transform ideas into powerful digital solutions. From health & wellness to AI-powered creativity, our apps are designed to make a difference.',
      ctaPrimary: 'Explore Our Apps',
      ctaSecondary: 'Learn More',
      ribbonText: 'Innovation • Excellence • Quality •',
    },
    
    // Apps Section
    apps: {
      label: 'Our Portfolio',
      headline: 'Apps That Make A Difference',
      description: 'Discover our collection of innovative mobile applications designed to enhance lives and solve real problems.',
      all: 'All',
      featured: 'Featured',
      reviews: 'reviews',
      website: 'Website',
    },
    
    // App Details
    appDetails: {
      drayly: {
        tagline: 'Logistics, Simplified.',
        description: 'A smart logistics and drayage platform that streamlines container moves, dispatch, and delivery tracking — keeping freight on schedule from port to door.',
      },
      slidecon: {
        tagline: 'Slides for Every Message.',
        description: 'An AI-powered slideshow generator for churches, educators, and presenters — turn your message into beautiful, ready-to-present slides in minutes.',
      },
      lumera: {
        tagline: 'Understand God\'s Word Like Never Before.',
        description: 'An AI-powered Bible companion — find truth instantly, explore Scripture with clarity, and grow in understanding through intelligent study and devotional guidance.',
      },
      vydlix: {
        tagline: 'Your Video Universe.',
        description: 'A next-generation video platform for discovering, streaming, and sharing short-form content with a feed that learns what you love.',
      },
      ideaqube: {
        tagline: 'Where Ideas Take Shape.',
        description: 'A collaborative idea and innovation hub to capture, organize, and develop concepts — turning scattered thoughts into actionable plans.',
      },
      arkmusic: {
        tagline: 'Create Music Like Never Before',
        description: 'AI-powered music creation platform featuring voice generation, stem separation, an extensive songs library, and engaging musical games. Unleash your inner artist.',
      },
      bienify: {
        tagline: 'Feel Good, Every Day.',
        description: 'A wellness companion for mindful living — track habits, mood, and self-care routines designed to help you feel your best, every day.',
      },
    },
    
    // Categories
    categories: {
      'Health & Fitness': 'Health & Fitness',
      'Music & Audio': 'Music & Audio',
      'Logistics': 'Logistics',
      'Creativity': 'Creativity',
      'Faith': 'Faith',
      'Entertainment': 'Entertainment',
      'Finance': 'Finance',
      'Social': 'Social',
      'Productivity': 'Productivity',
      'Travel': 'Travel',
    },
    
    // Services Section
    services: {
      label: 'What We Do',
      headline: 'Our Services',
      description: 'From concept to launch, we provide end-to-end app development services that turn your vision into reality.',
      items: {
        mobile: {
          title: 'Mobile App Development',
          description: 'Native and cross-platform apps built with cutting-edge technology for iOS and Android.',
        },
        uiux: {
          title: 'UI/UX Design',
          description: 'Beautiful, intuitive interfaces that users love and keep coming back to.',
        },
        ai: {
          title: 'AI Integration',
          description: 'Intelligent features powered by machine learning and artificial intelligence.',
        },
        backend: {
          title: 'Backend Solutions',
          description: 'Scalable, secure server infrastructure that grows with your application.',
        },
      },
    },
    
    // About Section
    about: {
      label: 'About Us',
      headline: 'We Build Apps That People Love',
      paragraph1: "At RDK Services LLC, we're passionate about creating mobile experiences that make a real difference in people's lives. Our team of expert developers, designers, and strategists work together to deliver exceptional applications.",
      paragraph2: "From initial concept to post-launch support, we partner with you every step of the way. Our commitment to quality, innovation, and user-centric design has made us a trusted name in the app development industry.",
      paragraph3: "Whether you're a startup with a bold idea or an established business looking to expand your digital presence, we have the expertise and creativity to bring your vision to life.",
      stats: {
        appsLaunched: 'Apps Launched',
        activeUsers: 'Active Users',
        awardsWon: 'Awards Won',
        countriesReached: 'Countries Reached',
      },
    },
    
    // Contact Section
    contact: {
      label: 'Get In Touch',
      headline: "Let's Build Something Amazing",
      description: "Have an app idea? We'd love to hear about it. Reach out and let's start a conversation.",
      form: {
        name: 'Name',
        namePlaceholder: 'Your name',
        email: 'Email',
        emailPlaceholder: 'your@email.com',
        subject: 'Subject',
        subjectPlaceholder: "What's this about?",
        message: 'Message',
        messagePlaceholder: 'Tell us about your project...',
        submit: 'Send Message',
        submitting: 'Processing...',
      },
      info: {
        email: 'Email',
        phone: 'Phone',
        address: 'Address',
      },
      cta: {
        title: 'Ready to start?',
        description: "Book a free consultation call and let's discuss how we can help bring your app idea to life.",
      },
      toast: {
        success: 'Message sent successfully!',
        successDescription: "We'll get back to you within 24 hours.",
      },
    },
    
    // Website Builder Showcase
    websiteBuilder: {
      badge: 'Web Development',
      headline: 'We Also Build Websites',
      description: 'Beyond mobile apps, we create stunning, high-performance websites that elevate your brand. From sleek landing pages to full-scale web applications, our team delivers digital experiences that convert.',
      cta: 'Start Your Project',
      ctaText: 'Ready to bring your website vision to life?',
      stats: {
        websites: 'Websites Delivered',
        responsive: 'Responsive Design',
        satisfaction: 'Client Satisfaction',
        support: 'Support Response'
      },
      capabilities: {
        design: 'Custom UI/UX Design',
        development: 'Modern Development',
        responsive: 'Mobile-First Approach',
        performance: 'Speed Optimized'
      },
      projects: {
        label: 'Recent Web Projects',
        types: {
          interior: 'Interior Design Studio',
          startup: 'Tech Startup',
          ecommerce: 'E-Commerce Brand',
          fitness: 'Fitness & Wellness'
        }
      }
    },

    // Footer
    footer: {
      description: 'We build innovative mobile applications and websites that transform ideas into powerful digital solutions. From health & wellness to AI-powered creativity, our products are designed to make a difference.',
      company: 'Company',
      support: 'Support',
      links: {
        aboutUs: 'About Us',
        ourApps: 'Our Apps',
        services: 'Services',
        careers: 'Careers',
        contact: 'Contact',
        faq: 'FAQ',
        privacyPolicy: 'Privacy Policy',
        termsOfService: 'Terms of Service',
      },
      copyright: '© 2026 RDK Services LLC. All rights reserved.',
      backToTop: 'Back to top',
    },
  },
  
  es: {
    // Navigation
    nav: {
      home: 'Inicio',
      apps: 'Apps',
      services: 'Servicios',
      about: 'Nosotros',
      contact: 'Contacto',
      getInTouch: 'Contáctanos',
    },
    
    // Hero Section
    hero: {
      badge: 'Estudio de Desarrollo de Apps',
      headline: 'Creando Experiencias Digitales Que Mueven a las Personas',
      description: 'Construimos aplicaciones móviles innovadoras que transforman ideas en soluciones digitales poderosas. Desde salud y bienestar hasta creatividad impulsada por IA, nuestras apps están diseñadas para marcar la diferencia.',
      ctaPrimary: 'Explorar Apps',
      ctaSecondary: 'Saber Más',
      ribbonText: 'Innovación • Excelencia • Calidad •',
    },
    
    // Apps Section
    apps: {
      label: 'Nuestro Portafolio',
      headline: 'Apps Que Marcan la Diferencia',
      description: 'Descubre nuestra colección de aplicaciones móviles innovadoras diseñadas para mejorar vidas y resolver problemas reales.',
      all: 'Todas',
      featured: 'Destacada',
      reviews: 'reseñas',
      website: 'Sitio Web',
    },
    
    // App Details
    appDetails: {
      drayly: {
        tagline: 'Logística, Simplificada.',
        description: 'Una plataforma inteligente de logística y drayage que agiliza el movimiento de contenedores, el despacho y el seguimiento de entregas, manteniendo la carga a tiempo desde el puerto hasta la puerta.',
      },
      slidecon: {
        tagline: 'Diapositivas Para Cada Mensaje.',
        description: 'Un generador de presentaciones impulsado por IA para iglesias, educadores y ponentes: convierte tu mensaje en hermosas diapositivas listas para presentar en minutos.',
      },
      lumera: {
        tagline: 'Comprende la Palabra de Dios Como Nunca Antes.',
        description: 'Un compañero bíblico impulsado por IA: encuentra la verdad al instante, explora las Escrituras con claridad y crece en entendimiento con estudio y guía devocional inteligente.',
      },
      vydlix: {
        tagline: 'Tu Universo de Video.',
        description: 'Una plataforma de video de nueva generación para descubrir, transmitir y compartir contenido de formato corto, con un feed que aprende lo que te encanta.',
      },
      ideaqube: {
        tagline: 'Donde las Ideas Toman Forma.',
        description: 'Un centro colaborativo de ideas e innovación para capturar, organizar y desarrollar conceptos, convirtiendo pensamientos dispersos en planes accionables.',
      },
      arkmusic: {
        tagline: 'Crea Música Como Nunca Antes',
        description: 'Plataforma de creación musical impulsada por IA con generación de voces, separación de pistas, extensa biblioteca de canciones y juegos musicales interactivos. Libera tu artista interior.',
      },
      bienify: {
        tagline: 'Siéntete Bien, Cada Día.',
        description: 'Un compañero de bienestar para una vida consciente: rastrea hábitos, estado de ánimo y rutinas de autocuidado diseñadas para ayudarte a sentirte mejor cada día.',
      },
    },
    
    // Categories
    categories: {
      'Health & Fitness': 'Salud y Fitness',
      'Music & Audio': 'Música y Audio',
      'Logistics': 'Logística',
      'Creativity': 'Creatividad',
      'Faith': 'Fe',
      'Entertainment': 'Entretenimiento',
      'Finance': 'Finanzas',
      'Social': 'Social',
      'Productivity': 'Productividad',
      'Travel': 'Viajes',
    },
    
    // Services Section
    services: {
      label: 'Lo Que Hacemos',
      headline: 'Nuestros Servicios',
      description: 'Desde el concepto hasta el lanzamiento, proporcionamos servicios integrales de desarrollo de apps que convierten tu visión en realidad.',
      items: {
        mobile: {
          title: 'Desarrollo de Apps Móviles',
          description: 'Apps nativas y multiplataforma construidas con tecnología de vanguardia para iOS y Android.',
        },
        uiux: {
          title: 'Diseño UI/UX',
          description: 'Interfaces hermosas e intuitivas que los usuarios aman y a las que vuelven una y otra vez.',
        },
        ai: {
          title: 'Integración de IA',
          description: 'Funciones inteligentes impulsadas por aprendizaje automático e inteligencia artificial.',
        },
        backend: {
          title: 'Soluciones Backend',
          description: 'Infraestructura de servidor escalable y segura que crece con tu aplicación.',
        },
      },
    },
    
    // About Section
    about: {
      label: 'Sobre Nosotros',
      headline: 'Creamos Apps Que la Gente Ama',
      paragraph1: 'En RDK Services LLC, nos apasiona crear experiencias móviles que marcan una diferencia real en la vida de las personas. Nuestro equipo de desarrolladores expertos, diseñadores y estrategas trabajan juntos para entregar aplicaciones excepcionales.',
      paragraph2: 'Desde el concepto inicial hasta el soporte post-lanzamiento, nos asociamos contigo en cada paso del camino. Nuestro compromiso con la calidad, la innovación y el diseño centrado en el usuario nos ha convertido en un nombre de confianza en la industria del desarrollo de apps.',
      paragraph3: 'Ya seas una startup con una idea audaz o un negocio establecido que busca expandir su presencia digital, tenemos la experiencia y creatividad para dar vida a tu visión.',
      stats: {
        appsLaunched: 'Apps Lanzadas',
        activeUsers: 'Usuarios Activos',
        awardsWon: 'Premios Ganados',
        countriesReached: 'Países Alcanzados',
      },
    },
    
    // Contact Section
    contact: {
      label: 'Contáctanos',
      headline: 'Construyamos Algo Increíble',
      description: '¿Tienes una idea de app? Nos encantaría escucharla. Contáctanos y comencemos una conversación.',
      form: {
        name: 'Nombre',
        namePlaceholder: 'Tu nombre',
        email: 'Correo',
        emailPlaceholder: 'tu@correo.com',
        subject: 'Asunto',
        subjectPlaceholder: '¿De qué se trata?',
        message: 'Mensaje',
        messagePlaceholder: 'Cuéntanos sobre tu proyecto...',
        submit: 'Enviar Mensaje',
        submitting: 'Procesando...',
      },
      info: {
        email: 'Correo',
        phone: 'Teléfono',
        address: 'Dirección',
      },
      cta: {
        title: '¿Listo para empezar?',
        description: 'Agenda una consulta gratuita y hablemos de cómo podemos ayudarte a dar vida a tu idea de app.',
      },
      toast: {
        success: '¡Mensaje enviado con éxito!',
        successDescription: 'Te responderemos en 24 horas.',
      },
    },

    // Website Builder Showcase
    websiteBuilder: {
      badge: 'Desarrollo Web',
      headline: 'También Construimos Sitios Web',
      description: 'Más allá de las apps móviles, creamos sitios web impresionantes y de alto rendimiento que elevan tu marca. Desde landing pages elegantes hasta aplicaciones web completas, nuestro equipo entrega experiencias digitales que convierten.',
      cta: 'Iniciar Tu Proyecto',
      ctaText: '¿Listo para dar vida a tu visión web?',
      stats: {
        websites: 'Sitios Web Entregados',
        responsive: 'Diseño Responsivo',
        satisfaction: 'Satisfacción del Cliente',
        support: 'Tiempo de Respuesta'
      },
      capabilities: {
        design: 'Diseño UI/UX Personalizado',
        development: 'Desarrollo Moderno',
        responsive: 'Enfoque Mobile-First',
        performance: 'Optimizado para Velocidad'
      },
      projects: {
        label: 'Proyectos Web Recientes',
        types: {
          interior: 'Estudio de Diseño Interior',
          startup: 'Startup Tecnológica',
          ecommerce: 'Marca E-Commerce',
          fitness: 'Fitness y Bienestar'
        }
      }
    },
    
    // Footer
    footer: {
      description: 'Construimos aplicaciones móviles y sitios web innovadores que transforman ideas en soluciones digitales poderosas. Desde salud y bienestar hasta creatividad impulsada por IA, nuestros productos están diseñados para marcar la diferencia.',
      company: 'Empresa',
      support: 'Soporte',
      links: {
        aboutUs: 'Sobre Nosotros',
        ourApps: 'Nuestras Apps',
        services: 'Servicios',
        careers: 'Carreras',
        contact: 'Contacto',
        faq: 'Preguntas Frecuentes',
        privacyPolicy: 'Política de Privacidad',
        termsOfService: 'Términos de Servicio',
      },
      copyright: '© 2026 RDK Services LLC. Todos los derechos reservados.',
      backToTop: 'Volver arriba',
    },
  },
};

// Helper function to get translation
export const getTranslation = (language, path) => {
  const keys = path.split('.');
  let result = translations[language];
  
  for (const key of keys) {
    if (result && result[key] !== undefined) {
      result = result[key];
    } else {
      return path; // Return path if translation not found
    }
  }
  
  return result;
};
